import { Add, GridView } from "@mui/icons-material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";
import { ButtonTable } from "../../Layouts/ButtonsControlled";
import { getAllPanels, reset } from "../../Redux/PanlesSlice/PanelsSlice";
import { Link, useLocation, useParams } from "react-router-dom";
import { openModal } from "../../Redux/modalSlice";
import ModalContainer from "../../Components/Modal/ModalContainer";
import { Outlet } from "react-router-dom";
import CreatePanels from "../Panels/CreatePanels";
const ApcAdder = () => {
    const location = useLocation();
    const path = location.pathname.split("/")[2];

    return (
        <>
            <HeaderTable>
                <div className="title">
                    <GridView />
                    <span>{path}</span>
                </div>
                <Link to="create">
                    <ButtonTable startIcon={<Add />}>New</ButtonTable>
                </Link>
            </HeaderTable>
            <Outlet />
        </>
    );
};

export default ApcAdder;
